export const SITE_URL = "https://litesoftit.com";
export const CLOUD_URL = "https://cloud.litesoftit.com";
export const SITE_NAME = "لايت سوفت";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/litesoft-02.PNG`;

export const homeSeo = {
  title: "لايت سوفت | أنظمة وحلول تقنية للشركات",
  description:
    "شركة لايت سوفت للأنظمة والحلول التقنية — برنامج محاسبة ونظام ERP، فوترة إلكترونية وربط ZATCA، وخدمات برمجية للشركات في السعودية واليمن والدول العربية. ابدأ مجاناً عبر النظام السحابي.",
  path: "/",
};

export const erpSeo = {
  title: "برنامج محاسبة ونظام ERP متكامل | فوترة إلكترونية ZATCA | لايت سوفت",
  description:
    "نظام ERP من لايت سوفت لإدارة المبيعات والمشتريات والمخزون والحسابات والتقارير، مع أنظمة قطاعية ودعم الفوترة الإلكترونية والربط مع هيئة الزكاة والضريبة والجمارك ومنصة فاتورة. ابدأ الاستخدام مجاناً عبر النظام السحابي.",
  path: "/erp",
};

export const organizationLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Litesoft",
  alternateName: "لايت سوفت",
  url: SITE_URL,
  logo: DEFAULT_OG_IMAGE,
  description: homeSeo.description,
  sameAs: [
    "https://www.facebook.com/profile.php?id=100063958034097",
    CLOUD_URL,
  ],
};

export const erpFaqs = [
  {
    q: "هل تدعمون الربط مع هيئة الزكاة والضريبة والجمارك؟",
    a: "نعم. أنظمة لايت سوفت تدعم الربط مع هيئة الزكاة والضريبة والجمارك (الزكاة والدخل) ومنصة فاتورة، مع مسارات إصدار وإرسال الفواتير الإلكترونية حسب إعداد المنشأة ومرحلة الالتزام.",
  },
  {
    q: "هل أنتم جاهزون للمرحلة الثانية (الربط والتكامل)؟",
    a: "نعم. المسارات تدعم المرحلة الأولى ومرحلة الربط والتكامل مع منصة فاتورة، بما يشمل الفواتير الضريبية والمبسّطة وضريبة القيمة المضافة VAT والمتابعة وإعادة الإرسال عند الحاجة.",
  },
  {
    q: "ما الوحدات الأساسية المتاحة في نظام ERP؟",
    a: "الحسابات، المبيعات والفواتير، المشتريات، المخزون، التقارير، والأمان والصلاحيات، مع أنظمة قطاعية حسب احتياج المنشأة.",
  },
  {
    q: "هل يمكن تخصيص برنامج المحاسبة لقطاع معيّن؟",
    a: "نعم. تتوفر أنظمة متخصصة للفنادق والاستراحات، المطاعم، الخياطة، المحطات النفطية، المراكز الطبية، الإنتاج، النقل، وغيرها حسب احتياج المنشأة.",
  },
  {
    q: "كيف أبدأ الربط أو عرضاً للنظام؟",
    a: "يمكنك بدء الاستخدام مجاناً عبر النظام السحابي على cloud.litesoftit.com، أو التواصل عبر نموذج الاتصال أو واتساب لتنسيق عرض النظام أو مسار الربط مع هيئة الزكاة والضريبة والجمارك ومنصة فاتورة.",
  },
];

export const softwareApplicationLd = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  name: "Litesoft ERP",
  applicationCategory: "BusinessApplication",
  operatingSystem: "Web",
  url: `${SITE_URL}/erp`,
  description: erpSeo.description,
  inLanguage: "ar",
  offers: {
    "@type": "Offer",
    availability: "https://schema.org/InStock",
    priceCurrency: "SAR",
    description: "تواصل لعرض سعر حسب احتياج منشأتك",
  },
  provider: {
    "@type": "Organization",
    name: "Litesoft",
    url: SITE_URL,
  },
};

export const faqPageLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: erpFaqs.map((item) => ({
    "@type": "Question",
    name: item.q,
    acceptedAnswer: {
      "@type": "Answer",
      text: item.a,
    },
  })),
};
